import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../hooks/useAuth';
import { RS_FEATURED_PUBLIC_BOARD_URL } from '../constants/reservationFeaturedBoard.config';
import { gaisukePublicPath } from '../utils/gaisukePath';
import { keibaArenaPublicPath } from '../utils/keibaArenaPath';
import { banquetPublicPath } from '../utils/banquetPath';
import { laboSukePublicPath } from '../utils/laboSukePath';
import { COMMUNICATION_BOARD_UI_ENABLED, isLaboSukePublicEnabled } from '../utils/config';
import { SAMPLE_STORAGE_SETUP_HREF } from '../utils/sampleStorageSetupGate';
export default function NotFound() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const laboSukePublic = isLaboSukePublicEnabled();

  return (
    <Container className="mt-5">
      <Helmet>
        <meta name="robots" content="noindex,nofollow" />
        <title>{t('not_found.title', { defaultValue: 'ページが見つかりません' })} | kensuke-system</title>
      </Helmet>
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <div className="text-center">
            <div className="mb-4">
              <i className="fas fa-exclamation-triangle fa-5x text-warning"></i>
            </div>
            <h1 className="display-1 text-muted">404</h1>
            <h2 className="mb-4">{t('not_found.title')}</h2>
            <p className="lead text-muted mb-4">{t('not_found.description')}</p>
            <div className="mb-4">
              <Button
                variant="primary"
                className="me-2"
                onClick={() => navigate(user ? '/dashboard' : '/')}
              >
                <i className="fas fa-home me-2" />
                {user
                  ? t('not_found.back_to_dashboard')
                  : t('not_found.back_to_home', { defaultValue: 'トップへ戻る' })}
              </Button>
              <Link to="/help" className="btn btn-outline-secondary">
                <i className="fas fa-question-circle me-2"></i>
                {t('not_found.view_help')}
              </Link>
            </div>
            <Card>
              <Card.Body>
                <h5>
                  {user
                    ? t('not_found.popular_pages')
                    : t('not_found.public_pages', { defaultValue: '公開ページ' })}
                </h5>
                {user ? (
                  <Row>
                    <Col md={6}>
                      <ul className="list-unstyled">
                        <li>
                          <Link to="/samples">{t('not_found.sample_management')}</Link>
                        </li>
                        <li>
                          <Link to={SAMPLE_STORAGE_SETUP_HREF}>
                            {t('not_found.storage_room_management', { defaultValue: '保管庫管理' })}
                          </Link>
                        </li>
                      </ul>
                    </Col>
                    <Col md={6}>
                      <ul className="list-unstyled">
                        <li>
                          <Link to="/users">{t('not_found.user_management')}</Link>
                        </li>
                        <li>
                          <Link to="/contact">{t('not_found.contact')}</Link>
                        </li>
                        <li>
                          <Link to="/help">{t('not_found.help')}</Link>
                        </li>
                      </ul>
                    </Col>
                  </Row>
                ) : (
                  <ul className="list-unstyled mb-0 text-start">
                    <li className="mb-2">
                      <Link to="/">{t('not_found.link_home', { defaultValue: 'トップ' })}</Link>
                    </li>
                    <li className="mb-2">
                      <a
                        href={RS_FEATURED_PUBLIC_BOARD_URL}
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        {t('home.feature_reservation_public_cta', {
                          defaultValue: 'デモ画面',
                        })}
                      </a>
                    </li>
                    <li className="mb-2">
                      <Link to={gaisukePublicPath(i18n.language)}>
                        {t('home.feature_gaisuke_cta', { defaultValue: 'AIトレードArenaを開く' })}
                      </Link>
                    </li>
                    <li className="mb-2">
                      <Link to={keibaArenaPublicPath(i18n.language)}>
                        {t('home.feature_keiba_arena_cta', {
                          defaultValue: 'AI競馬アリーナを開く',
                        })}
                      </Link>
                    </li>
                    <li className="mb-2">
                      <Link to={banquetPublicPath(i18n.language)}>
                        {t('home.feature_banquet_cta', {
                          defaultValue: '熱狂の宴を開く',
                        })}
                      </Link>
                    </li>
                    {laboSukePublic ? (
                      <li className="mb-2">
                        <Link to={laboSukePublicPath(i18n.language)}>
                          {t('home.feature_labo_suke_cta', { defaultValue: 'ラボ助を開く' })}
                        </Link>
                      </li>
                    ) : null}
                    <li className="mb-2">
                      <Link to="/help">{t('not_found.help')}</Link>
                    </li>
                    {COMMUNICATION_BOARD_UI_ENABLED ? (
                      <li>
                        <Link to="/contact">{t('not_found.contact')}</Link>
                      </li>
                    ) : null}
                  </ul>
                )}
              </Card.Body>
            </Card>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
